import React from 'react';

import AboutUs from '../components/AboutUs';
import Values from '../components/Values';
import Explore from '../components/Explore';

import Hero from '../components/Hero';

const Home = () => {
    return (
        <>
            <Hero />
            <AboutUs />
            <Values />
            <Explore />
        </>
    );
};

export default Home;
